import { render } from "./CoverageTable.vue?vue&type=template&id=2a25f2ac"
import script from "./CoverageTable.vue?vue&type=script&lang=js"
export * from "./CoverageTable.vue?vue&type=script&lang=js"

import "./CoverageTable.vue?vue&type=style&index=0&id=2a25f2ac&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__